const MONTH_PATTERN = /^\d{4}-(0[1-9]|1[0-2])$/;

/** The current calendar month in Norwegian time, as YYYY-MM. */
export const currentNorwegianMonth = (): string => {
    const parts = new Intl.DateTimeFormat('en', {
        timeZone: 'Europe/Oslo',
        year: 'numeric',
        month: '2-digit',
    }).formatToParts(new Date());
    return `${parts.find(part => part.type === 'year')?.value}-${
        parts.find(part => part.type === 'month')?.value
    }`;
};

export const isMonthValue = (value: string | null | undefined): boolean =>
    Boolean(value && MONTH_PATTERN.test(value));
